import { render, staticRenderFns } from "./DashboardBannerTile.vue?vue&type=template&id=191eb5d6&scoped=true&"
import script from "./DashboardBannerTile.vue?vue&type=script&lang=js&"
export * from "./DashboardBannerTile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBannerTile.vue?vue&type=style&index=0&id=191eb5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191eb5d6",
  null
  
)

export default component.exports